import * as IconSelector from '../icons';

export const censos = [
    {
        value: null,
        label: 'Sin definir',
        description: 'Sin censo definido',
        icon: IconSelector.PointIcon,
        color: 'Black'
    },
    {
        value: 'JUMILLA',
        label: 'JUMILLA',
        description: 'JUMILLA',
        icon: IconSelector.PointIcon,
        color: 'Blue'
    },
    {
        value: 'ALBATANA',
        label: 'ALBATANA',
        description: 'ALBATANA',
        icon: IconSelector.PointIcon,
        color: 'Blue'
    },
    {
        value: 'ONTUR',
        label: 'ONTUR',
        description: 'ONTUR',
        icon: IconSelector.PointIcon,
        color: 'Blue'
    },
    {
        value: 'HELLIN',
        label: 'HELLIN',
        description: 'HELLIN',
        icon: IconSelector.PointIcon,
        color: 'Blue'
    },
    {
        value: 'TOBARRA',
        label: 'TOBARRA',
        description: 'TOBARRA',
        icon: IconSelector.PointIcon,
        color: 'Blue'
    },
    {
        value: 'FUENTEALAMO',
        label: 'FUENTEALAMO',
        description: 'FUENTEALAMO',
        icon: IconSelector.PointIcon,
        color: 'Blue'
    },
    {
        value: 'MONTEALEGRE',
        label: 'MONTEALEGRE',
        description: 'MONTEALEGRE',
        icon: IconSelector.PointIcon,
        color: 'Blue'
    },
    {
        value: 'No Inscrita',
        label: 'No Inscrita',
        description: 'Bodega no inscrita en la DOP',
        icon: IconSelector.PointIcon,
        color: 'Red'
    }
];
